import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {CLIENTS_PATH, CREATE_CLIENTS_PATH, SCOPES_PATH} from '@/pages/Routes';
import {getToken} from "@/utils/ProtectedApiCall";
import {hasAdminRoles, TokenResponse} from "@/utils/RoleUtils";

const Navigation: React.FC = () => {
  const [userRoles, setUserRoles] = useState<boolean>(false)
  useEffect(() => {
    getToken().then((res: TokenResponse) => {
      const hasRoles = hasAdminRoles(res);
      setUserRoles(hasRoles);
    });
  }, []);

  return (
    <ul className='overflow-hidden'>
      <li className='float-left margin-right'>
        <Link to={CLIENTS_PATH}>Clients</Link>
      </li>
      <li className='float-left margin-right'>
        <Link to={SCOPES_PATH}>Scopes</Link>
      </li>
      {userRoles &&
        <li className='float-left margin-right'>
          <Link to={CREATE_CLIENTS_PATH}>Create New Client</Link>
        </li>
      }
    </ul>
  );
};

export default Navigation;
